export interface FieldSelectionSummary {
  custom: number;
  standard: number;
  total: number;
}

export interface PartitionedFieldSelection {
  customFields: string[];
  standardFields: string[];
}

/** Splits selected values into the disjoint field lists expected by the submission API. */
export const partitionSelectedFields = (
  selectedFields: readonly string[],
  customFieldValues: readonly string[]
): PartitionedFieldSelection => {
  const uniqueSelectedFields = Array.from(new Set(selectedFields));
  const customValues = new Set(customFieldValues);

  return {
    customFields: uniqueSelectedFields.filter((value) => customValues.has(value)),
    standardFields: uniqueSelectedFields.filter((value) => !customValues.has(value)),
  };
};

/** Counts unique selected fields and classifies selected custom values without double-counting. */
export const getFieldSelectionSummary = (
  selectedFields: readonly string[],
  customFieldValues: readonly string[]
): FieldSelectionSummary => {
  const partitionedFields = partitionSelectedFields(selectedFields, customFieldValues);

  return {
    custom: partitionedFields.customFields.length,
    standard: partitionedFields.standardFields.length,
    total: partitionedFields.customFields.length + partitionedFields.standardFields.length,
  };
};
